exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tittlesDetails[data-v-1be65fa2]{font-size:1.4rem;font-weight:700}.v-list__tile[data-v-1be65fa2]{padding:0!important}", ""]);

// exports
